
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div v-if="getCurrentStep === 3" class="step step-2">
    <div class="documents py-4 px-sm-4 p-md-5">
      <h1 class="text-primary mb-5 font-45px">
        {{ $t("documents_informations") }}
      </h1>
      <b-row>
        <b-col cols="12" xl="8" offset-xl="2">
          <b-card
            class="border-raduis-xl border-color-muted box-shadow-sm"
            body-class="p-sm-5"
          >
            <b-row
              v-for="document in getDocuments"
              :key="document.id"
              class=" mb-3 py-1 px-4"
            >
              <b-col
                cols="12"
                xl="4" 
                class="d-flex align-items-center"
              >
                <div class="w-100 d-block">
                  <div
                    v-b-tooltip.hover
                    :title="document.name"
                    class="document d-flex align-items-center border border-raduis-sm border-color-muted"
                  >
                    <span class="icon text-center text-primary mr-2">
                      <b-icon icon="file-earmark"></b-icon>
                    </span>
                    <span class="title text-truncate">
                      {{ document.name }}
                    </span>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                xl="4"
                class="d-flex align-items-center justify-content-start justify-content-xl-center mt-2 mt-xl-0"
              >
                <p class="my-2 m-lg-0">{{ $t("specify_content_document") }}</p>
              </b-col>
              <b-col cols="12" xl="4" class="d-flex align-items-center">
                <multiselect 
                  open-direction="bottom"
                  :closeOnSelect="false"
                  v-model="valueSelect[document.id]"
                  :options="getDocumentsTypes"
                  :placeholder="$t('type_document')"
                  :multiple="true"
                  trackBy="id"
                  label="name"
                  :showLabels="false"
                  class="tags-outline"
                >
                  <template slot="caret">
                    <div
                      class="multiselect__select d-flex align-items-center justify-content-center"
                    >
                      <div
                        v-if="
                          valueSelect[document.id] &&
                          valueSelect[document.id].length
                        "
                        class="text-primary"
                      >
                        <b-icon icon="pencil-fill"></b-icon>
                      </div>
                      <div v-else>
                        <b-icon icon="chevron-down"></b-icon>
                      </div>
                    </div>
                  </template>
                  <template slot="option" slot-scope="props">
                    <div class="option__desc d-flex justify-content-between">
                      <span class="option__title">{{ props.option.name }}</span>
                      <span
                        class="option__info-icon right"
                        :desc="props.option.info"
                      >
                        <b-icon class="text-muted" icon="info-circle"></b-icon>
                      </span>
                    </div>
                  </template>
                </multiselect>
              </b-col>
            </b-row>
          </b-card>
          <b-card
            class="border-raduis-xl border-color-muted box-shadow-sm mt-4"
            body-class="p-3"
          >
            <b-row>
              <b-col cols="12" sm="6" class="text-sm-right mb-2 mb-sm-0">
                <b-button
                  @click="backToPreviousStep"
                  pill
                  variant="outline-primary"
                  class="py-2 px-5"
                >
                  <span>{{ $t("previous") }}</span>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6" class="text-sm-left">
                <b-button pill variant="primary" class="py-2 px-5">
                  <span> {{ $t("save") }}</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'AddDocumentStep2',
  props: {},
  data() {
    return {
      valueSelect: {},
    };
  },
  computed: {
    ...mapGetters('document', ['getCurrentStep', 'getStep1Status']),
    ...mapGetters('document', ['getDocuments', 'getDocumentsTypes']),
  },
  mounted() {
    this.getDocumentsTypesAction();
  },
  methods: {
    ...mapMutations('document', ['setCurrentStep', 'setStep1Status']),
    ...mapActions('document', [
      'getDocumentsAction',
      'getDocumentsTypesAction',
    ]),
    limitText(count) {
      return this.$tc('multiselect_limit_text', count);
    },
    backToPreviousStep() {
      this.setCurrentStep(1);
    },
  },
};
</script>
